import api from 'libs/axios/api';
import { apiService } from 'libs/axios/services';

export const getThreshold = async (
): Promise<ApiResponse<ResponseBase<IThreshold>>> => {
    return apiService.get<undefined, ResponseBase<IThreshold>>(
        api.threshold,
        undefined,
        undefined,
        true,
    );
};

export const createThreshold= async (
    body: IThresholdCreate,
): Promise<ApiResponse<any>> => {
    return apiService.post<IThresholdCreate, any>(
        api.threshold,
        body,
        undefined,
        true,
    );
};

export const updateThreshold= async (data: {
    body: IThresholdUpdate;
    id: string;
}): Promise<ApiResponse<any>> => {
    return apiService.put<IThresholdUpdate, any>(
        `${api.threshold}/${data.id}`,
        data.body,
        undefined,
        true,
    );
};
